import styled from 'styled-components';
export const StyledSearchForm = styled.form.withConfig({
  displayName: "StyledSearchForm",
  componentId: "sc-11xd8x7-0"
})(["display:flex;align-items:stretch;flex-grow:1;justify-content:flex-start;width:100%;overflow:hidden;position:relative;"]);